/* unplugin-vue-components disabled */import { render } from "./ColorHeightProjectionRender.vue?vue&type=template&id=79bbecb4&scoped=true"
import script from "./ColorHeightProjectionRender.vue?vue&type=script&lang=js"
export * from "./ColorHeightProjectionRender.vue?vue&type=script&lang=js"

import "./ColorHeightProjectionRender.vue?vue&type=style&index=0&id=79bbecb4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bbecb4"]])

export default __exports__